// extracted by mini-css-extract-plugin
module.exports = {"dialog":"crm-c_dialog__1iY79","container":"crm-c_container__2q2E7","actionButton":"crm-c_actionButton__tbJPd","form":"crm-c_form__3cYNu","select":"crm-c_select__OCp64"};